import React from "react";
import { TextField, MenuItem } from "@mui/material";

/**
 * MergeValueEditCell
 * - TextField editor by default
 * - Select dropdown when row.__status === 'merged'
 * - Options via params.colDef.getMergeOptions(params)
 */
const MergeValueEditCell = (params) => {
  const isMerged = params?.row?.__status === "merged";
  const value = params.value ?? "";
  const [open, setOpen] = React.useState(true); // auto-open for select

  const onChange = (e) => {
    const val = e.target.value;
    try {
      params.api.setEditCellValue(
        { id: params.id, field: params.field, value: val },
        e
      );
    } catch (_) {}
  };

  if (isMerged) {
    let options = [];
    try {
      const provider = params?.colDef?.getMergeOptions;
      if (typeof provider === "function") {
        const out = provider(params);
        if (Array.isArray(out)) options = out;
        else if (out && Array.isArray(out.values)) options = out.values;
      }
    } catch (_) {}
    // de-dup and sanitize
    options = Array.from(new Set((options || []).filter(Boolean)));

    return (
      <TextField
        select
        fullWidth
        autoFocus
        size="small"
        variant="outlined"
        value={value}
        onChange={onChange}
        SelectProps={{
          open,
          onOpen: () => setOpen(true),
          onClose: () => setOpen(false),
          MenuProps: {
            disablePortal: false,
            PaperProps: { sx: { zIndex: 20000, maxHeight: 280, fontSize: 12 } },
            MenuListProps: {
              dense: true,
              sx: {
                "& .MuiMenuItem-root": {
                  fontSize: 12,
                  lineHeight: 1.2,
                  minHeight: "unset",
                  py: 0.5,
                },
              },
            },
          },
        }}
        sx={{
          height: "100%",
          "& .MuiInputBase-root": {
            height: "100%",
            alignItems: "center",
            fontSize: 12,
          },
          "& .MuiOutlinedInput-input": {
            padding: "2px 8px",
            fontSize: 12,
            lineHeight: 1.2,
          },
          "& .MuiSelect-select": {
            padding: "2px 8px",
            fontSize: 12,
            lineHeight: 1.2,
          },
        }}
      >
        {options.length === 0 ? (
          <MenuItem value="" disabled>
            No suggestions
          </MenuItem>
        ) : (
          options.map((opt) => (
            <MenuItem key={opt} value={opt}>
              {opt}
            </MenuItem>
          ))
        )}
      </TextField>
    );
  }

  return (
    <TextField
      fullWidth
      autoFocus
      size="small"
      variant="outlined"
      value={value}
      onChange={onChange}
      placeholder="Enter value"
      sx={{
        height: "100%",
        "& .MuiInputBase-root": {
          height: "100%",
          alignItems: "center",
          fontSize: 12,
        },
        "& .MuiOutlinedInput-input": {
          padding: "2px 8px",
          fontSize: 12,
          lineHeight: 1.2,
        },
      }}
    />
  );
};

export default MergeValueEditCell;
